import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import {
  InvoicesColumn,
  InvoicesColumns,
} from "@portal/BaseComponents/Table/Components/Invoices/InvoicesColumn";
import { DocumentList } from "@portal/types/entities/documents";
import {
  CellRenderProps,
  defaultCellComponents,
} from "@sinecycle/growcomponents";

import { useMemo } from "react";
import { getDocumentConfig } from "../../predicate";

function AssociatedWith(props: CellRenderProps<DocumentList>) {
  const { data } = props;

  function getInvoices(): InvoicesColumns[] {
    if (!data) return [];
    return data.invoices.map((invoice) => {
      return {
        id: invoice.id,
        title: invoice.number,
        amount: invoice.balance_due_amount,
        currency: invoice.currency,
      };
    });
  }

  const invoices = useMemo(getInvoices, [data]);

  if (!data) return;
  const Invoices = <InvoicesColumn {...props} value={invoices} />;
  return (
    <Flex align="center" justify="start" space="12">
      {defaultCellComponents.statusCell({
        ...props,
        value: data.type.entity_type,
        statusCellProps: {
          getter: getDocumentConfig,
        },
      })}

      <HideWrapper hide={data.type.entity_type !== "INVOICE"}>
        {data.mapping_type === "ALL" ? null : Invoices}
      </HideWrapper>
    </Flex>
  );
}

export { AssociatedWith };
